"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterestWithSubtargetsToJSON = exports.InterestWithSubtargetsFromJSONTyped = exports.InterestWithSubtargetsFromJSON = exports.instanceOfInterestWithSubtargets = void 0;
var runtime_1 = require("../runtime");
var TargetBase_1 = require("./TargetBase");
/**
 * Check if a given object implements the InterestWithSubtargets interface.
 */
function instanceOfInterestWithSubtargets(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfInterestWithSubtargets = instanceOfInterestWithSubtargets;
function InterestWithSubtargetsFromJSON(json) {
    return InterestWithSubtargetsFromJSONTyped(json, false);
}
exports.InterestWithSubtargetsFromJSON = InterestWithSubtargetsFromJSON;
function InterestWithSubtargetsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'subtargets': !(0, runtime_1.exists)(json, 'subtargets') ? undefined : (json['subtargets'].map(TargetBase_1.TargetBaseFromJSON)),
    };
}
exports.InterestWithSubtargetsFromJSONTyped = InterestWithSubtargetsFromJSONTyped;
function InterestWithSubtargetsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'subtargets': value.subtargets === undefined ? undefined : (value.subtargets.map(TargetBase_1.TargetBaseToJSON)),
    };
}
exports.InterestWithSubtargetsToJSON = InterestWithSubtargetsToJSON;
